import { useQuery } from '@tanstack/react-query'
import { request } from 'src/editor/shared/utils/request'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export interface ContactField {
  id: number
  fieldName: string
  slug: ContactSlugEnum
}

const fetchContactFields = async (): Promise<ContactField[]> => {
  const response = await request.get(
    '/api/dashboard/customer/contact/fields/list',
  )
  return response.data.items
}

export const useContactFields = () => {
  return useQuery<ContactField[], Error>({
    queryKey: ['contactFields'],
    queryFn: fetchContactFields,
    staleTime: 1000 * 60 * 60, // one hour
    retry: 2,
  })
}
